// Action Types
export const GET_CHECK_HANDS_DATA = 'GET_CHECK_HANDS_DATA';
export const GET_CHECK_HANDS_DATA_SUCCESS = 'GET_CHECK_HANDS_DATA_SUCCESS';
export const GET_CHECK_HANDS_DATA_FAILURE = 'GET_CHECK_HANDS_DATA_FAILURE';

// Action Creators
export const getCheckHandsData = (params) => ({
  type: GET_CHECK_HANDS_DATA,
  payload: params,
});

export const getCheckHandsDataSuccess = (data) => ({
  type: GET_CHECK_HANDS_DATA_SUCCESS,
  payload: { data },
});

export const getCheckHandsDataFailure = (error) => ({
  type: GET_CHECK_HANDS_DATA_FAILURE,
  payload: { error },
});